module.exports = __webpack_public_path__ + "img/285.30a7e087.png";